import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IMPORT_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IImportSchema } from '~/Models/DTO/Import.model';

export const useRequestImportDataScheme = () => {
  const { isLoading, isFetching, error, data, refetch } = useQuery<IImportSchema[], IErrorResponse>(
    [REQUEST_ACTIONS.GET_INVOICE_DOWNLOAD_URL],
    () =>
      requestReactQuery<IImportSchema[]>({
        url: IMPORT_URLS.IMPORT_DATA_SCHEMA,
        config: { method: 'GET' },
      }),
    {
      enabled: false,
    },
  );

  return {
    isDataSchemeLoading: isLoading,
    isDataSchemeFetching: isFetching,
    dataSchemeError: error,
    dataScheme: data,
    refetchImportDataScheme: refetch,
  };
};
